/**
 * Family member record — the canonical data shape for SFP's people directory.
 *
 * Stored at Firestore `familyMembers/{memberId}`. Every nested field is
 * optional so the wizard can save progress mid-fill and so the record can
 * grow as live integrations (Plaid, prescription APIs, etc.) backfill data.
 *
 * Uploaded ID documents are stored separately under
 * `gs://<bucket>/family/{memberId}/{docKind}/{filename}` and linked here by
 * `storagePath` + `downloadUrl` (the URL is captured on upload so we don't
 * regenerate signed URLs every read).
 *
 * Sensitive fields (SSN, full medical history) MUST be admin-only at the
 * Firestore-rules layer.
 */
export const FAMILY_RELATIONSHIPS = [
    'self',
    'spouse',
    'parent',
    'child',
    'sibling',
    'grandparent',
    'grandchild',
    'cousin',
    'aunt_uncle',
    'niece_nephew',
    'in_law',
    'partner',
    'other',
];
export const ADDRESS_KINDS = ['home', 'work', 'mailing', 'vacation', 'other'];
export const PHONE_KINDS = ['mobile', 'home', 'work', 'other'];
export const MARITAL_STATUSES = [
    'single',
    'married',
    'partnered',
    'divorced',
    'separated',
    'widowed',
    'other',
];
export const ID_DOC_KINDS = [
    'passport',
    'drivers_license',
    'birth_certificate',
    'social_security_card',
    'state_id',
    'green_card',
    'naturalization_certificate',
    'marriage_certificate',
    'other',
];
export const BLOOD_TYPES = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-', 'unknown'];
export function emptyFamilyMember() {
    return {
        id: '',
        legalFirstName: '',
        legalLastName: '',
        emails: [],
        phones: [],
        addresses: [],
        emergencyContacts: [],
        idDocuments: [],
        medical: {
            doctors: [],
            prescriptions: [],
            insurance: [],
        },
        financial: {},
        estate: {},
        status: 'active',
        revision: 0,
    };
}
export function displayName(m) {
    const first = m.preferredName?.trim() || m.legalFirstName?.trim() || '';
    const last = m.legalLastName?.trim() || '';
    return [first, last, m.suffix?.trim()].filter(Boolean).join(' ').trim() || 'Unnamed member';
}
//# sourceMappingURL=family-member.js.map